import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { useLogEvent } from '~/hooks/useLogEvent'

import { useArchiveStrategyMemoMutation } from '../hooks/useArchiveStrategyMemoMutation'
import {
  type StrategyMemo,
  useInvalidateStrategyMemosInfiniteQuery,
} from '../hooks/useStrategyMemosInfiniteQuery'

export type ArchiveButtonProps = {
  strategyMemo: StrategyMemo
}

export const ArchiveButton = ({ strategyMemo }: ArchiveButtonProps) => {
  const { t } = useTranslation()
  const invalidateStrategyMemosInfiniteQuery =
    useInvalidateStrategyMemosInfiniteQuery()
  const logEvent = useLogEvent()
  const archiveStrategyMemoMutation = useArchiveStrategyMemoMutation({
    onSuccess: () => {
      invalidateStrategyMemosInfiniteQuery()
      logEvent('Delete customer strategy')
    },
  })
  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    archiveStrategyMemoMutation.mutate(strategyMemo.id)
  }, [archiveStrategyMemoMutation, strategyMemo.id])

  return (
    <StyledButton
      disabled={archiveStrategyMemoMutation.isPending}
      fillMode="outline"
      icon="delete"
      onClick={handleClick}
    >
      {t('delete_5')}
    </StyledButton>
  )
}
